import {
  SETTINGS_MARKET_SECTOR_CLEAR_SNACKBAR,
  SETTINGS_GET_MARKET_SECTOR,
  SETTINGS_GET_MARKET_SECTOR_LOADING,
  SETTINGS_DELETE_MARKET_SECTOR_SUCCESS,
  SETTINGS_ADD_MARKET_SECTOR_SUCCESS,
  SETTINGS_ADD_MARKET_SECTOR_ERROR,
  SETTINGS_MARKET_SECTOR_ERROR,
} from "../constants/types";

const initialState = {
  marketSector: [],
  loading: true,
  status: "success",
  text: "",
  showSnackbar: false,
};

const marketSectorReducer = (state = initialState, action) => {
  switch (action.type) {
    case SETTINGS_MARKET_SECTOR_CLEAR_SNACKBAR:
      return {
        ...state,
        showSnackbar: false,
      };
    case SETTINGS_GET_MARKET_SECTOR:
      return {
        ...state,
        ...action.payload,
        showSnackbar: false,
      };
    case SETTINGS_GET_MARKET_SECTOR_LOADING:
      return {
        ...state,
        loading: true,
      };
    case SETTINGS_DELETE_MARKET_SECTOR_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case SETTINGS_ADD_MARKET_SECTOR_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case SETTINGS_ADD_MARKET_SECTOR_ERROR:
      return {
        ...state,
        ...action.payload,
      };
    case SETTINGS_MARKET_SECTOR_ERROR:
      return {
        ...state,
        loading: false,
        status: action.payload.status,
        text: action.payload.text,
        showSnackbar: true,
      };

    default:
      return state || {};
  }
};

export default marketSectorReducer;
